module.exports = __webpack_public_path__ + "static/img/LxxljkscV4.dfe4f425.png";